import Container from './Container'
import { Spacing, Heading, ReviewStars } from '@big-red-group/storefront-common-ui'
import Icon from './Icons'
import AustraliaBackgroundOutline from './AustraliaBackgroundOutline'
import {
  TextContent,
  Card,
  CardDescription,
  Cards,
  Description,
  Feefo,
  SectionWrap,
  Wrapper,
  CardColumnLeft,
  CardColumnRight,
} from './WhyBookWithUs.styles'

const WhyBookWithUs = () => {
  return (
    <SectionWrap data-mcp-id="promise-points">
      <Container noSpacingTop>
        <Wrapper>
          {/* Header */}
          <TextContent>
            <Heading size="XL">Why Experience Oz?</Heading>
            <Description>
              With 4,000 experiences waiting to be discovered, we make your family holidays easier - and better - than
              ever.
            </Description>
            <Spacing />
            <ReviewStars rating={4.6} />
            <Feefo>
              <p>4.5/5 Feefo Rating</p>
              <span>86% independent Feefo positive rating from 4,208 customers </span>
            </Feefo>
          </TextContent>
          {/* TODO icons */}
          <Cards>
            <CardColumnLeft>
              <Card variant="yellow">
                <Icon name="cash" />
                <Heading size="XS" spacing={false}>
                  Unbeatable value
                </Heading>
                <CardDescription>Best value experiences with a price guarantee.</CardDescription>
              </Card>
              <Card variant="black">
                <Icon name="koala" />
                <Heading size="XS" spacing={false} style={{ color: 'white' }}>
                  Aussie owned
                </Heading>
                <CardDescription>Trusted by locals & supporting local businesses.</CardDescription>
              </Card>
            </CardColumnLeft>
            <CardColumnRight>
              <Card variant="black">
                <Icon name="heartHands" stroke="white" />
                <Heading size="XS" spacing={false} style={{ color: 'white' }}>
                  Here (almost) always
                </Heading>
                <CardDescription>363 days of support via phone or live chat.</CardDescription>
              </Card>
              <Card variant="yellow">
                <Icon name="trophy" />
                <Heading size="XS" spacing={false}>
                  Trusted by thousands
                </Heading>
                <CardDescription>4.5/5 independent Feefo rating from over 16,000 reviews.</CardDescription>
              </Card>
            </CardColumnRight>
          </Cards>
        </Wrapper>
      </Container>
      <AustraliaBackgroundOutline />
    </SectionWrap>
  )
}

export default WhyBookWithUs
